import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimActKC2OtherGql } from '../../bimWorkOrderQueries';

const requestId = 'bimActKC2Other';

export const useBimActKC2Other = (actKC2OtherId?: number) => {
    const [bimActKC2OtherReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ actKC2OtherId }), [actKC2OtherId]);

    const [bimActKC2OtherData, bimActKC2OtherStatus] = useRequest({
        requestId,
        query: bimActKC2OtherGql,
        variables,
        withEffect: Boolean(actKC2OtherId),
    });

    useEffect(() => {
        bimActKC2OtherReset(null);
    }, [bimActKC2OtherReset]);

    return {
        bimActKC2OtherData,
        bimActKC2OtherStatus,
    };
};
